import React, { useEffect, useRef, useState } from "react";
import { BulkUploadWrapper } from "../../Components/PayoutBulkUpload/style";

import { CSVLink } from "react-csv";
import Proceed from "../../Components/PayoutBulkUpload/Proceed";
import Pagination from "../../Components/Pagination/Pagination";
import FileUploadBox from "../../Components/UploadFile/FileUploadBox";
import { getFundData, getFundFiles, uploadFundFile } from "../../utils/api";
import { AlertWrapper } from "../../Components/Modal/style";
import { isEmpty } from "../../utils/common";
import { useSelector } from "react-redux";


function BulkWalletBalance() {
  const [reportsItems, setReportsItems] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [paging_data, setPagingData] = useState(null);
  const [currntPage, setCurrentpage] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailLoader, setDetailLoader] = useState(false);
  const [details, setDetails] = useState([]);
  const [openBox, setOpenBox] = useState({});
  const [selectRecord, setSelectRecord] = useState({});
  const [msg, setMsg] = useState({});
  const [message, setMessage] = useState({});
  const [rejectedUsers, setRejectedUsers] = useState({});
  const [file, setFile] = useState(null);
  const [customPagination, setCustomPagination] = useState({
    currentPage: 0,
    totalPage: 1,
    pageSize: 20,
  });
  const [searchKey, setSearchKey] = useState("");
  const downloadRef = useRef();
  const csvRef = useRef();

  useEffect(() => {
    getListing(0);
  }, []);

  const getListing = (page_no, page_size = 10, isDownload = false) => {
    const params = {
      pagination: {
        pageNo: page_no,
        pageSize: page_size,
      },
      uploadedBy: "",
      fromDate: "",
      toDate: "",
    };
    setCurrentpage(0);

    getFundFiles(params).then((res) => {
   
      if (isDownload && res?.data?.data?.content) {
        setDownloadData(res?.data?.data?.content);
      } else {
        setPagingData(res?.data?.data);
        setReportsItems(res?.data?.data?.content);

        setSelectRecord(res?.data?.data?.content[0] || {});
        getDeitalClick(res?.data?.data?.content[0]?.fileId);
      }
    });
  };

  const getCurrentPageData = (page_no) => {
    getListing(page_no);
  };

  const onDownloadClick = () => {
    if (paging_data && paging_data?.totalElements) {
      getListing(0, paging_data?.totalElements, true);
    }
  };

  useEffect(() => {
    if (Array.isArray(downloadData) && downloadData.length > 0) {
      setTimeout(() => {
        downloadRef.current.link.click();
      }, 1000);
    }
  }, [downloadData]);

  const onUploadFile = () => {
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    uploadFundFile(formData)
      .then((resp) => {
        if (resp?.data?.success) {
          setFile(null)
          setMsg({ type: "success", msg: "File uploaded successfully" });
          if (isEmpty(!resp?.data?.data?.rejectedUsers)) {
            setRejectedUsers(resp?.data?.data?.rejectedUsers);
          }
          getListing(0);
        } else {
          setLoading(false);
          console.log("resp", resp);
          const msg = resp?.data?.msg;
          if (resp?.data?.errorCodeList?.length) {
            msg = resp?.errorCodeLis.toString();
          }
          setMsg({ type: "error", msg: msg });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (uploadMsg) {
  //     setTimeout(() => {
  //       setUploadMsg("");
  //     }, 3000);
  //   }
  // }, [uploadMsg]);

  const getDeitalClick = (fileId) => {
    setDetailLoader(true);
    const params = {
      fileId: fileId,
    };
    getFundData(params).then((response) => {
      setDetailLoader(false);
      if (response?.data?.data) {
        setSearchKey("");
        setDetails(response?.data?.data || []);
        setFilterData(response?.data?.data || []);

        const totalRecord = response?.data?.data.length;
        const totalPage = Math.ceil(totalRecord / customPagination?.pageSize);

        setCustomPagination({
          ...customPagination,
          totalPage: totalPage,
          currentPage: 0,
        });
      }
    });
  };

  const selectCard = (item) => {
    if (selectRecord?.fileId === item?.fileId) return;
    setSelectRecord(item);
    getDeitalClick(item.fileId);
  };

  const csvDownload = () => {
    csvRef.current.link.click();
  };

  const onReconClick = (uuid) => {
    //    bulkUploadReconRequest(uuid).then((response) => {
    //      console.log("bulkUploadReconRequest", response);
    //    });
  };

  const setCurrentPage_ = (page) => {
    setCustomPagination({ ...customPagination, currentPage: page });
  };

  const search = (e) => {
    const { value } = e.target;

    const filterData_ = details.filter(
      (item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.userMobile.toLowerCase().includes(value.toLowerCase())
    );
    setSearchKey(value);

    const totalRecord = filterData_.length;
    const totalPage = Math.ceil(totalRecord / customPagination?.pageSize);
    setCustomPagination({
      ...customPagination,
      totalPage: totalPage,
      currentPage: 0,
    });
    setFilterData(filterData_);
  };

 useState(() =>{
 
  if(isEmpty(message)) return;
 
  setTimeout(() =>{
    setMessage({});
  }, 5000)

 },[message]);

   const { user } = useSelector((state) => state.user);

   console.log("user",user,selectRecord)

  return (
    <div className="main_container">
      <BulkUploadWrapper>
        <div className="left">
          <div className="tab-card-upload active">
            <FileUploadBox
              onUploadFile={setFile}
              fileUpload={file}
              accept=".csv"
            />
          </div>
          {!file ? (
            <a
              href="./file/bulk_sample_file.csv"
              download
              style={{
                display: "inline-block",
                paddingTop: "4px",
                marginBottom: "20px",
              }}
            >
              Download sample
            </a>
          ) : (
            <div className="userlist_right">
              <button
                onClick={onUploadFile}
                disabled={loading}
                style={{ marginBlock: "10px", width: "auto" }}
              >
                Upload File
              </button>
            </div>
          )}

          {!isEmpty(msg) && (
            <AlertWrapper className={`${msg?.type} local`}>
              <span className="close" onClick={() => setMsg({})}>
                ×
              </span>
              {msg.msg}
            </AlertWrapper>
          )}
          {!isEmpty(rejectedUsers) && (
            <AlertWrapper className={`error local`}>
              <span className="close " style={{top:"14px"}} onClick={() => setRejectedUsers({})}>
                ×
              </span>
              <div>
                <div>Rejected Users</div>
                <div style={{ whiteSpace: "wrap" }}>
                  <ul>
                  {!isEmpty(rejectedUsers) &&
                    (Object.keys(rejectedUsers) || {}).map((key) => {
                     
                      return <li>{`${key} - ${rejectedUsers?.[key]}`} </li>;
                    })}
                    </ul>
                </div>
              </div>
            </AlertWrapper>
          )}

          {reportsItems &&
            reportsItems.map((value, i) => {
              return (
                <div
                  className={`${
                    value.fileId === selectRecord.fileId ? "active" : ""
                  } card`}
                  key={i}
                  onClick={() => selectCard(value)}
                >
                  <div className="desc">
                    <h4>{value?.fileName}</h4>
                    <p>
                      Total Amount: <span>₹{value?.totalAmount}</span>{" "}
                    </p>
                    <p>
                      Total Count: <span>{value?.totalRecords}</span>{" "}
                    </p>
                  </div>
                  <div className="button">
                    <span>{value?.fileStatus}</span>
                  </div>
                </div>
              );
            })}
        </div>

        <div className="right">
          <div className="header">
            <div className="data">
              <h3>{selectRecord?.fileName}</h3>

              <p>
                Created Date:{" "}
                {selectRecord?.uploadedAt &&
                  (selectRecord?.uploadedAt || "").replace("T", " ")}
              </p>
              {selectRecord?.fileStatus === "PROCESSED" && (
                <>
                  <p>
                    Processed Records: {selectRecord?.totalProcessedRecords}
                  </p>
                  <p>Processed Amount: ₹{selectRecord?.totalProcessedAmount}</p>
                </>
              )}
            </div>
            <div className="download ">
              <div className="flex">
                {selectRecord?.fileStatus &&
                  selectRecord?.fileStatus === "PENDING" && (user?.uuid === selectRecord?.uploadedBy
                    ) && (
                    <Proceed
                      className="processButton"
                      item={selectRecord}
                      getListing={getListing}
                      setMessage={setMessage}
                    />
                  )}
                <div className="userlist_right">
                  <button class="xls" onClick={csvDownload}>
                    CSV
                  </button>
                  <CSVLink
                    filename={
                      selectRecord?.fileName
                        ? selectRecord.fileName.replace(".csv", "")
                        : "Download Csv"
                    }
                    className="csv-link-hide"
                    data={details}
                    ref={csvRef}
                  />
                  {/* {selectRecord?.status && selectRecord?.status === "COMPLETED" && (
                    <BorderBtn
                      className="btn-soft-success"
                      onClick={() => onReconClick(item?.uuid)}
                    >
                      <i className="fa fa-download" aria-hidden="true"></i>RECON
                    </BorderBtn>
                  )} */}
                </div>
              </div>
              <div className="search">
                <input
                  type="search"
                  name=""
                  id=""
                  placeholder="Search..."
                  value={searchKey}
                  onChange={search}
                />
              </div>
            </div>
          </div>

          {!isEmpty(message) && (
            <div className="center">
              <AlertWrapper className={`${message?.type} local`}>
                <span className="close" onClick={() => setMessage({})}>
                  ×
                </span>
                {message.msg}
              </AlertWrapper>
            </div>
          )}
          <div className="record">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Retailer Name</th>
                  <th>Mobile</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {!detailLoader &&
                  filterData &&
                  filterData
                    .slice(
                      customPagination.currentPage * customPagination.pageSize,
                      (customPagination.currentPage + 1) *
                        customPagination.pageSize
                    )
                    .map((value, i) => {
                      return (
                        <>
                          <tr key={i}>
                            <td>
                              {customPagination.currentPage *
                                customPagination.pageSize +
                                (i + 1)}
                            </td>
                            <td>{value?.name}</td>
                            <td>{value?.userMobile}</td>
                            <td>₹ {value?.amount}</td>
                            <td>
                              {" "}
                              {(value?.recordStatus || "").toLowerCase()}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                {detailLoader && (
                  <tr>
                    <td colSpan={"100%"}>Loading...</td>
                  </tr>
                )}
                {!detailLoader && isEmpty(details) && (
                  <tr>
                    <td colSpan={"100%"} style={{ textAlign: "center" }}>
                      No record round
                    </td>
                  </tr>
                )}
                {!detailLoader && !isEmpty(details) && isEmpty(filterData) && (
                  <tr>
                    <td colSpan={"100%"} style={{ textAlign: "center" }}>
                      No record match
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {!detailLoader && customPagination?.totalPage > 1 && (
            <div div style={{ marginBottom: "20px" }}>
              <Pagination
                items={details}
                currentPage={customPagination?.currentPage}
                setcurrentPage={setCurrentPage_}
                totalPages={customPagination?.totalPage}
              />
            </div>
          )}
        </div>
      </BulkUploadWrapper>
      <div className="flex">
        <div>
          {reportsItems && paging_data?.totalPages > 1 && (
            <Pagination
              items={reportsItems}
              // itemsPerPage={2}
              currentPage={currntPage}
              setcurrentPage={getCurrentPageData}
              totalPages={paging_data?.totalPages}
              forcePage={currntPage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default BulkWalletBalance;
